import React from 'react'

const Performance = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="performanceSvg"
    >
      <g
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5.25.75a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" className="darkColor" />
        <path d="M5.25 8.25v6" className="lightColor" />
        <path d="M7.5 23.25l.75-7.5h1.5v-3a4.5 4.5 0 0 0-9 0v3h1.5l.75 7.5h4.5zM12.75 14.25h9a1.5 1.5 0 0 0 1.5-1.5V2.25a1.5 1.5 0 0 0-1.5-1.5h-10.5" className="darkColor" />
        <path d="M12 9l2.25-2.25L16.5 9l3.75-3.75" className="lightColor" />
        <path d="M17.25 5.25h3v3" className="lightColor" />
        <path d="M15.75 14.25v5.25M12.75 19.5h6" className="darkColor" />
      </g>
    </svg>
  )
}

export default Performance
